<template>
  <div class="profile">
    <section class="d-flex flex-column">
      <header class="masthead mb-auto">
        <nav class="navbar navbar-expand-lg navbar-dark bg-no-trans">
				<div class="container-fluid">
					<a class="navbar-brand" href="/#/">
						<img src="../../assets/img/logo.png" alt="Logo" />
					</a>
					<ul class="navbar-nav ml-auto align-items-center navWithSearch">
					<li class="nav-item">
              <a class="nav-link" href="#" tabindex="-1" aria-disabled="true">
                <img
                  v-bind:src="require(`@/assets/img/${this.n}.png`)"
                  alt
                  height="40px"
                  width="40px"
                  style="vertical-align: top"
                />
              </a>
            </li>
           <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                id="dropdown01"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                > {{  }}</a
              >
              <div
                class="dropdown-menu dropdown-menu-right front"
                aria-labelledby="dropdown01"
              >
                <span class="dropdown-menu-arrow"></span>
                <a class="dropdown-item front" href="/#/profile2"> Manage Profile</a>
                <a class="dropdown-item front" href="/#/account">Account</a>
                <a class="dropdown-item front" href="/#/mediaCenter">Help Center</a>
                <a class="dropdown-item pointer front" @click="logout">Sign Out</a>
              </div>
            </li>
					</ul>
				</div>
			</nav>
      </header>
    </section>
    <section v-if="!showPopup" class="py-5 bg-grey200">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-8">
            <div class="card custom-card">
              <div class="card-body">
                <h2 class="text-center mt-3">Edit Profile</h2>
                <div class="row my-5 justify-content-center">
                  <div class="col-md-3 text-center">
                    <img
                      v-bind:src="require(`@/assets/img/${this.n}.png`)"
                      alt
                      class="icon"
                      width="100"
                    />
                    <a @click="edit"
                      >Edit
                      <i
                        class="fa fa-pencil-square-o pointer"
                        aria-hidden="true"
                      ></i
                    ></a>
                  </div>
                  <div class="col-md-4">
                    <form class="form-light">
                      <div class="form-group">
                        <input
                          type="text"
                          class="form-control"
                          id=""
                          v-model="name"
                          placeholder="Enter  name"
                        />
                      </div>
                      <div class="form-group">
                        <select
                          v-model="PreferredLanguage"
                          class="form-control"
                          placeholder="Language"
                        >
                          <option
                            v-for="(language, index) in languages"
                            :key="index"
                            :value="language"
                          >
                            {{ language.name }}
                          </option>
                        </select>
                      </div>
                      <div class="form-group">
                        <select
                          v-model="gender"
                          placeholder="Gender"
                          class="form-control"
                        >
                          <option>Male</option>
                          <option>Female</option>
                        </select>
                      </div>
                      <div class="form-group">
                        <input
                          type="date"
                          v-model="date"
                          class="form-control"
                          id=""
                          placeholder="Date of Birth"
                        />
                      </div>
                    </form>
                  </div>
                </div>
                <div class="row justify-content-center">
                  <div class="col-md-12 text-center">
                    <button
                      type="submit"
                      @click="submit"
                      class="btn btn-outline-light"
                    >
                      SAVE
                    </button>
                    <button
                      type="button"
                      @click="cancel"
                      class="btn btn-outline-light ml-5"
                    >
                      CANCEL
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section v-if="showPopup">
      <Profile3
        :previousImage="n"
        @clicked="onClickSelected"
        @clickedcancel="cancelSelected"
      />
    </section>
  </div>
</template>

<script>
import HomeNav from "@/components/HomeNav.vue";
import Profile3 from "@/pages/profile/Profile3.vue";

export default {
  name: "Profile2",
  components: {
    HomeNav,
    Profile3,
  },
  data() {
    return {
      data: null,
      showPopup: false,
      n: null,
      name: "",
      PreferredLanguage: "",
      gender: "",
      date: "",
      profileData: "",
      telephone:"",
      firstName: "",
      lastName: "",
      username:"",
      telephone: "",
      email: "",
      metaData: {
        image_id: "",
        language: "",
        dob: "",
        gender: "",
      },
      languages: [],
      profile: "",
    };
  },
  mounted() {
    window.scroll(0, 0);
  },
  created() {
    this.$store.commit("showPopup", false);
    
    this.languages = JSON.parse(
      this.$store.state.globalconfigs.language_option
    );
    this.$store.commit("setLoader", true);
    this.$store.dispatch("account").then((res) => {
      this.$store.commit("setLoader", false);
      this.profileData = res.response.profile.metaData;
      this.name = res.response.name;
      this.username = res.response.profile.first_name;
      this.telephone= res.response.profile.telephone;
      this.email = res.response.profile.username;
      // this.lastName = res.response.profile.last_name;
      if (this.profileData.image_id) {
        this.n = this.profileData.image_id;
      } else {this.n = 0}
      this.PreferredLanguage = this.profileData.language;
      this.gender = this.profileData.gender;
      this.date = this.profileData.dob;
    })
    .catch((err) => {
					this.$store.commit("setLoader", false);
				});

    if (this.$store.state.user.logedin == false) {
      this.$router.push("/login");
      return false;
    }
    this.data = this.$store.state.user;
    this.$store.commit("showdefaultFooter", true);
    

  },
  methods: {
    logout() {
      this.$store.dispatch("logout").then((res) => {
        if (res == "true") {
          this.$router.push("/login");
        }
      });
    },
    onClickSelected(value) {
      this.n = value;
     // this.profile.image_id = value;
      this.showPopup = false;
    },

    edit() {
      this.showPopup = true;
    },
    cancelSelected() {
      this.showPopup = false;
    },
    submit() {
      (this.metaData.image_id = this.n),
        (this.metaData.language = this.PreferredLanguage.name),
        (this.metaData.dob = this.date),
        (this.metaData.gender = this.gender);
      var name = this.name.split(" ");
      if (name.length > 1) {
        this.firstName = name[0];
        this.lastName = name[1];
      } else if (name.length <= 1) {
        this.firstName = name[0];
        this.lastName = "";
      }
      this.UpdateProfile();
    },
    cancel() {
      this.$router.push("/home");
    },
    UpdateProfile() {
      var self = this;
      
      var dataToSend = {
        metaData: this.metaData,
        firstName: this.firstName,
        lastName: this.lastName,
        telephone:this.telephone,
        email:this.email

      };
      this.$store.commit("setLoader", true);
      this.$store
        .dispatch("UpdateProfile", dataToSend)
        .then((res) => {
          if (res) {
            self.$store.commit(
              "setNotification",
              " profile Updated Sucessfully!! "
            );
            self.$store.commit("setLoader", false);
            this.$router.push("/home");
          }
        })
        .catch((err) => {
          self.$store.commit("setLoader", false);
          self.$store.commit(
            "setNotification",
            " Error while updating profile "
          );
        });
    },
  },
  computed: {},
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}

.container{
  padding-top: 8rem !important;
  padding-bottom: 8rem !important;
  min-height: 80vh;
}
</style>
